import { OrderTransaction } from "../billingData";

export function buildCumulativeChartData(transactions: OrderTransaction[]) {
    // Step 1: Filter for 'order' transactions only
    const orders = transactions.filter((tx) => tx.type === 'order');
  
    // Step 2: Group by date
    // TODO: replace with net just gross for now as lack of data
    const dailySums: Record<string, number> = {};
    for (const tx of orders) {
      const date = tx.date.split('T')[0]; // Get YYYY-MM-DD
      dailySums[date] = (dailySums[date] || 0) + tx.grossAmount;
    }
  
    // Step 3: Sort dates
    const sortedDates = Object.keys(dailySums).sort();
  
    // Step 4: Build cumulative chart data
    let cumulativeTotal = 0;
    const chartData = sortedDates.map((date) => {
      cumulativeTotal += dailySums[date];
      return {
        date,
        value: cumulativeTotal,
      };
    });
  
    return chartData;
  }